module.exports = __webpack_public_path__ + "static/media/0111.8491142e.png";